const formattingTokenStrings = [
    's',
    'm',
    'mm',
    'h',
    'hh',
    'd',
    'dd',
    'M',
    'MM',
    'y',
    'yy',
] as const;

type FormattingToken = (typeof formattingTokenStrings)[number];

type FormattingFunction = (
    input: number,
    withoutSuffix: boolean,
    token: FormattingToken,
    isFuture: boolean,
) => string;

export type RelativeTimeConfig = Record<FormattingToken, FormattingFunction>;

export function createRelativeTimeConfig(
    formattingFn: FormattingFunction,
): RelativeTimeConfig {
    return Object.fromEntries(
        formattingTokenStrings.map((token) => [token, formattingFn]),
    ) as RelativeTimeConfig;
}
